<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Calculadora de Comissões</h3>
        </div>

        <d-list-group
          style="box-shadow: rgba(0, 0, 0, 0.1) 0px 3px  8px, rgba(0, 0, 0, 0) 0px 6px 20px 0px"
          class="col-12 mt-4"
        >
          <div v-if="!isDataReady" style="background-color: #fff; padding-top: 25px">
            <loader :is-loading="isDataReady"></loader>
          </div>
          <div v-else>
            <ValidationObserver ref="formValidation">
              <d-list-group-item class="p-5">

                <!-- FORMULA VALOR FIXO -->
                <d-form-row>
                  <d-col md="12">
                    <div class="float-right">
                      <p style="padding-left: 2rem; text-align: left">
                        Confira o cálculo para serviços com 
                          <span style="font-weight: bold; font-size: 1.2rem">valores fixos</span>:
                      </p>
                      <div style="margin-bottom: 3rem; height: 100%; width: 100%;">
                        <vue-mathjax style="font-size: 8pt;" :formula="formula"></vue-mathjax>
                      </div>
                    </div>
                  </d-col>
                </d-form-row>

                <!--BOLETO-->
                <d-form-row>
                  <d-col md="12" xl="7" class="form-group">
                    <div class="mb-5">
                      <d-form-row>
                        <d-col class="text-left">
                          <label class="h4">{{ CommissionCompetences.BankSlip.Name }}</label>
                        </d-col>
                        <d-col class="text-right">
                          <span class="h5">Comissão</span>
                        </d-col>
                      </d-form-row>
                      <d-form-row>
                        <d-col md="3">
                          <!-- <label class="mb-0 tax-type">{{ CommissionCompetences.BankSlip.Taxes[0].TaxType.Id == 1 ? "Percentual \(%\)" : "Valor \(R$\)" }}</label> -->
                          <label class="mb-0 tax-type">Valor (R$)</label>
                          <ValidationProvider 
                            :rules="{
                              required: true,
                              min_value: parseFloat(CommissionCompetences.BankSlip.Labels[0].replace(',', '.')),
                              max_value: parseFloat(CommissionCompetences.BankSlip.Labels[CommissionCompetences.BankSlip.Labels.length - 1].replace(',', '.')),
                            }" v-slot="{ errors, invalid }"
                          >
                            <decimal-field v-model="BankSlipTax" id="BankSlip" class="calc" :class="validatedTax | showValidateError(invalid)"
                              :type="CommissionCompetences.BankSlip.Taxes[0].TaxType.Id == 1 ? 'percentage' : 'currency'" />
                            <div class="invalid-feedback d-block invalid-tax" v-if="validatedTax">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </d-col>
                        <d-col align-self="end" class="small">
                          <div>
                            <span>Valor mínimo de 
                              <span style="font-weight: bold;">{{ CommissionCompetences.BankSlip.Labels[0] }}</span>
                            </span>
                            <br>
                            <span>Valor máximo de 
                              <span style="font-weight: bold;">{{ CommissionCompetences.BankSlip.Labels[CommissionCompetences.BankSlip.Labels.length - 1] }}</span>
                            </span>
                          </div>
                        </d-col>
                        <d-col class="text-right mr-2">
                          <p class="h5" style="color: green; font-weight: bold;">{{ CalcBankSlipCommission | percentage }}</p>
                        </d-col>
                      </d-form-row>
                    </div>

                    <label class="mb-0">Número de boletos:</label>
                    <d-input
                      type="number"
                      class="mt-1"
                      v-model="BankSlipQuantity"
                      placeholder="Insira o número de boletos"
                    />
                  </d-col>

                  <d-col md="12" xl="5" align-self="end">
                    <div class="float-right">
                      <div class="ml-10">
                        <p style="font-size: 15px; margin-bottom: 5px; text-align: center;">Este é o valor de sua comissão:</p>
                        <div style="height: auto; text-overflow: ellipsis; width: 305px; background-color:#0ad8dd; border-radius: 27px;">
                          <p v-if="this.BankSlipQuantity == undefined || this.BankSlipQuantity == ''"
                            style="text-align: center; margin-bottom: 1rem; font-size: 28px; padding: 2px; font-family: 'Cairo', sans-serif;color:#00304d;"
                          >
                            R$ 0,00
                          </p>
                          <p v-else
                            style="height: auto; word-break: break-all; margin-bottom: 1rem; text-align: center; font-size: 28px; padding: 2px; font-family: 'Cairo', sans-serif;color:#00304d;"
                          >
                            {{ BankSlipResult | toCurrency }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </d-col>
                </d-form-row>

                <!--PIX-->
                <d-form-row style="margin-top: 55px;">
                  <d-col md="12" xl="7" class="form-group">
                    <div class="mb-5 pt-3">
                      <d-form-row>
                        <d-col class="text-left">
                          <label class="h4">{{ CommissionCompetences.Pix.Name }}</label>
                        </d-col>
                        <d-col class="text-right">
                          <span class="h5">Comissão</span>
                        </d-col>
                      </d-form-row>
                      <d-form-row>
                        <d-col md="3">
                          <label class="mb-0 tax-type">Valor (R$)</label>
                          <ValidationProvider 
                            :rules="{
                              required: true,
                              min_value: parseFloat(CommissionCompetences.Pix.Labels[0].replace(',', '.')),
                              max_value: parseFloat(CommissionCompetences.Pix.Labels[CommissionCompetences.Pix.Labels.length - 1].replace(',', '.')),
                            }" v-slot="{ errors, invalid }"
                          >
                            <decimal-field v-model="PixTax" id="Pix" class="calc" :class="validatedTax | showValidateError(invalid)"
                              :type="CommissionCompetences.Pix.Taxes[0].TaxType.Id == 1 ? 'percentage' : 'currency'" />
                            <div class="invalid-feedback d-block invalid-tax" v-if="validatedTax">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </d-col>
                        <d-col align-self="end" class="small">
                          <div>
                            <span>Valor mínimo de 
                              <span style="font-weight: bold;">{{ CommissionCompetences.Pix.Labels[0] }}</span>
                            </span>
                            <br>
                            <span>Valor máximo de 
                              <span style="font-weight: bold;">{{ CommissionCompetences.Pix.Labels[CommissionCompetences.Pix.Labels.length - 1] }}</span>
                            </span>
                          </div>
                        </d-col>
                        <d-col class="text-right mr-2">
                          <p class="h5" style="color: green; font-weight: bold;">{{ CalcPixCommission | percentage }}</p>
                        </d-col>
                      </d-form-row>
                    </div>

                    <label class="mb-0">Número de transações:</label>
                    <d-input
                      type="number"
                      class="mt-1"
                      v-model="PixQuantity"
                      placeholder="Insira o número de transações"
                    />
                  </d-col>

                  <d-col md="12" xl="5" align-self="end">
                    <div class="float-right">
                      <div class="ml-10">
                        <p style="font-size: 15px; margin-bottom: 5px; text-align: center;">Este é o valor de sua comissão:</p>
                        <div style="height: auto; text-overflow: ellipsis; width: 305px; background-color:#0ad8dd; border-radius: 27px;">
                          <p v-if="this.PixQuantity == undefined || this.PixQuantity == ''"
                            style="text-align: center; margin-bottom: 1rem; font-size: 28px; padding: 2px; font-family: 'Cairo', sans-serif;color:#00304d;"
                          >
                            R$ 0,00
                          </p>
                          <p v-else
                            style="height: auto; word-break: break-all; margin-bottom: 1rem; text-align: center; font-size: 28px; padding: 2px; font-family: 'Cairo', sans-serif;color:#00304d;"
                          >
                            {{ PixResult | toCurrency }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </d-col>
                </d-form-row>

                <hr style="margin: 5rem 0 3rem 0;" />

                <!-- FORMULA VALOR VARIÁVEL -->
                <d-form-row>
                  <d-col md="12">
                    <div class="float-right">
                      <p style="padding-left: 2rem; text-align: center">
                        Confira o cálculo para serviços com 
                          <span style="font-weight: bold; font-size: 1.2rem">percentuais</span>:
                      </p>
                      <div style="margin-bottom: 3rem; height: 100%; width: 100%;">
                        <vue-mathjax style="font-size: 8pt;" :formula="formulaVariable"></vue-mathjax>
                      </div>
                    </div>
                  </d-col>
                </d-form-row>

                <!--CARTAO DE CREDITO-->
                <d-form-row>
                  <d-col md="12" xl="7" class="form-group">
                    <div class="mb-5 pt-3">
                      <d-form-row>
                        <d-col class="text-left">
                          <label class="h4">{{ CommissionCompetences.CreditCard.Name }}</label>
                        </d-col>
                        <d-col class="text-right">
                          <span class="h5">Comissão</span>
                        </d-col>
                      </d-form-row>
                      <d-form-row>
                        <d-col md="3">
                          <label class="mb-0 tax-type">Percentual (%)</label>
                          <ValidationProvider 
                            :rules="{
                              required: true,
                              min_percentage: parseFloat(CommissionCompetences.CreditCard.Labels[0].replace(',', '.')),
                              max_percentage: parseFloat(CommissionCompetences.CreditCard.Labels[CommissionCompetences.CreditCard.Labels.length - 1].replace(',', '.')),
                            }" v-slot="{ errors, invalid }"
                          >
                            <decimal-field v-model="CreditCardTax" id="CreditCard" class="calc" :class="validatedTax | showValidateError(invalid)"
                              :type="CommissionCompetences.CreditCard.Taxes[0].TaxType.Id == 1 ? 'percentage' : 'currency'" />
                            <div class="invalid-feedback d-block invalid-tax" v-if="validatedTax">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </d-col>
                        <d-col align-self="end" class="small">
                          <div>
                            <span>Valor mínimo de 
                              <span style="font-weight: bold;">{{ CommissionCompetences.CreditCard.Labels[0] }}</span>
                            </span>
                            <br>
                            <span>Valor máximo de 
                              <span style="font-weight: bold;">{{ CommissionCompetences.CreditCard.Labels[CommissionCompetences.CreditCard.Labels.length - 1] }}</span>
                            </span>
                          </div>
                        </d-col>
                        <d-col class="text-right mr-2">
                          <p class="h5" style="color: green; font-weight: bold;">{{ CalcCreditCardCommission | percentage }}</p>
                        </d-col>
                      </d-form-row>
                    </div>

                    <label class="mb-0">Valor total das transações: (R$)</label>
                    <b-input
                      type="number"
                      class="mt-1"
                      v-model="totalCreditCard"
                      placeholder="Insira o valor total das transações"
                    />
                  </d-col>

                  <d-col md="12" xl="5" align-self="end">
                    <div class="float-right">
                      <div class="ml-10">
                        <p style="font-size: 15px; margin-bottom: 5px; text-align: center;">Este é o valor de sua comissão:</p>
                        <div
                          style="height: auto; text-overflow: ellipsis; width: 305px; background-color:#0ad8dd; border-radius: 27px;"
                        >
                          <p v-if="this.totalCreditCard == undefined || this.totalCreditCard == ''"
                            style="text-align: center; margin-bottom: 1rem; font-size: 28px; padding: 2px; font-family: 'Cairo', sans-serif;color:#00304d;"
                          >
                            R$ 0,00
                          </p>
                          <p v-else
                            style="height: auto; word-break: break-all; margin-bottom: 1rem; text-align: center; font-size: 28px; padding: 2px; font-family: 'Cairo', sans-serif;color:#00304d;"
                          >
                            {{ CreditCardResult | toCurrency }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </d-col>
                </d-form-row>

                <hr style="margin-top: 3.5rem;" />

                <!-- TOTAL -->
                <d-form-row>
                  <d-col md="12">
                    <div class="d-flex flex-row flex-wrap justify-content-end" style="margin-top: 3.5rem;">
                      <div class="mr-5">
                        <p style="margin-bottom: 0px; font-size: 36px; font-family: 'Cairo', sans-serif;">
                          TOTAL =
                        </p>
                      </div>
                      <div style="height: auto; text-overflow: ellipsis; width: 305px; background-color:#009400; border-radius: 27px;">
                        <p style="height: auto; margin-bottom: 0px; word-break: break-all; text-align: center; font-size: 36px;font-family: 'Cairo', sans-serif;color:#fff;">
                          {{ (BankSlipResult + PixResult + CreditCardResult) | toCurrency }}
                        </p>
                      </div>
                    </div>
                  </d-col>
                </d-form-row>
              </d-list-group-item>
            </ValidationObserver>
          </div>
        </d-list-group>
      </div>
    </div>

    <a
      href="#"
      class="btn-float btn"
      style="background: #0ad8dd; color: black"
      v-show="showBtnScroll"
      v-on:click="ScrollToTop($event)"
    >
      <i class="fa fa-chevron-up"></i>
    </a>
  </div>
</template>

<script>
import rangeSlider from "../common/range-slider";
import { VueMathjax } from "vue-mathjax";
import decimalField from "../common/decimal-field.vue";

export default {
  components: {
    rangeSlider,
    VueMathjax,
    decimalField
  },
  data: function() {
    return {
      formula: "$$Comissão = {ValorSelecionado * PorcentagemComissão\\over 100} * Quantidade$$",
      formulaVariable: "$$Comissão = {PorcentagemSelecionada * ValorTotalTransações \\over 100} * {PorcentagemComissão \\over 100}$$",
      BankSlipQuantity: undefined,
      PixQuantity: undefined,
      totalCreditCard: undefined,
      bRange: {
        labels: ["R$ 1,96", "R$ 1,83", "R$ 1,55"],
        min: 1,
        max: 3,
        value: 1
      },
      BankSlipTax: 0,
      PixTax: 0,
      CreditCardTax: 0,
      showBtnScroll: false,
      isDataReady: false,
      validatedTax: true,
    };
  },
  computed: {
    CommissionCompetences() {
      return this.$store.getters.CommissionCompetence;
    },
    CalcBankSlipCommission: {
      get() { return this.$store.getters.CalcBankSlipCommission },
      set(value) { this.$store.commit("SET_CALC_BANKSLIP_COMMISSION", value) }
    },
    CalcPixCommission: {
      get() { return this.$store.getters.CalcPixCommission },
      set(value) { this.$store.commit("SET_CALC_PIX_COMMISSION", value) }
    },
    CalcCreditCardCommission: {
      get() { return this.$store.getters.CalcCreditCardCommission },
      set(value) { this.$store.commit("SET_CALC_CREDITCARD_COMMISSION", value) }
    },
    BankSlipResult() {
      if (this.BankSlipQuantity) {
        const quantity = parseInt(this.BankSlipQuantity);
        if (!Number.isNaN(quantity)) {
          const result = ((this.BankSlipTax * this.CalcBankSlipCommission) / 100) * quantity;
          if (result != undefined && !Number.isNaN(result)) {
            return result;
          }
        }
      }
      return 0.0;
    },
    PixResult() {
      if (this.PixQuantity) {
        const quantity = parseInt(this.PixQuantity);
        if (!Number.isNaN(quantity)) {
          const result = ((this.PixTax * this.CalcPixCommission) / 100) * quantity;
          if (result != undefined && !Number.isNaN(result)) {
            return result;
          }
        }
      }
      return 0.0;
    },
    CreditCardResult() {
      const total = parseFloat(this.totalCreditCard);
      if (!Number.isNaN(total)) {
        const result = ((this.CreditCardTax * total) / 100) * (this.CalcCreditCardCommission / 100);
        if (result != undefined && !Number.isNaN(result)) {
          return result;
        }
      }
      return 0.0;
    }
  },
  watch: {
    CommissionCompetences: function() {
      const numCommissionCompetences = Object.keys(this.CommissionCompetences).length;
      if (numCommissionCompetences > 0) {
        const avaiablePaymentMethods = ["BankSlip", "CreditCard", "Pix"];

        for (const method of avaiablePaymentMethods) {
          const numberOfTaxes = this.CommissionCompetences[method].Taxes.length;
          const highestTax = this.CommissionCompetences[method].Taxes[numberOfTaxes - 1].Tax;
          const commission = this.CommissionCompetences[method].Taxes[numberOfTaxes - 1].Commission;

          if (method == "BankSlip") {
            this.BankSlipTax = highestTax;
            this.$store.commit("SET_CALC_BANKSLIP_COMMISSION", commission);
          }
          if (method == "Pix") {
            this.PixTax = highestTax;
            this.$store.commit("SET_CALC_PIX_COMMISSION", commission);
          }
          if (method == "CreditCard") {
            this.CreditCardTax = highestTax;
            this.$store.commit("SET_CALC_CREDITCARD_COMMISSION", commission);
          }
        }

        this.isDataReady = true;
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.HandleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.HandleScroll);
  },
  mounted() {
    const numCommissionCompetences = Object.keys(this.CommissionCompetences).length;
    if (numCommissionCompetences > 0) {
      this.InitConfig();
    } else {
      this.$requestGetCommissionCompetence();

      let mathJax = document.createElement("script");
      mathJax.setAttribute(
        "src",
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML"
      );
      document.head.appendChild(mathJax);
    }
  },
  methods: {
    InitConfig: function() {
      const avaiablePaymentMethods = ["BankSlip", "CreditCard", "Pix"];

      for (const method of avaiablePaymentMethods) {
        const numberOfTaxes = this.CommissionCompetences[method].Taxes.length;
        const highestTax = this.CommissionCompetences[method].Taxes[numberOfTaxes - 1].Tax;
        const commission = this.CommissionCompetences[method].Taxes[numberOfTaxes - 1].Commission;

        if (method == "BankSlip") {
          this.BankSlipTax = highestTax;
          this.$store.commit("SET_CALC_BANKSLIP_COMMISSION", commission);
        }
        if (method == "Pix") {
          this.PixTax = highestTax;
          this.$store.commit("SET_CALC_PIX_COMMISSION", commission);
        }
        if (method == "CreditCard") {
          this.CreditCardTax = highestTax;
          this.$store.commit("SET_CALC_CREDITCARD_COMMISSION", commission);
        }
      }

      this.isDataReady = true;
    },
    HandleScroll: function() {
      if (
        document.body.scrollTop > 800 ||
        document.documentElement.scrollTop > 800
      ) {
        this.showBtnScroll = true;
      } else {
        this.showBtnScroll = false;
      }
    },
    ScrollToTop: function() {
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style scoped>
.invalid-tax {
  position: absolute;
  font-weight: bold;
  font-size: 0.7rem;
}

.tax-type {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/calculator.vue